<po-page-default p-title="Relatório de Acumuladores - Domínio" [p-breadcrumb]="breadcrumb">
    <div class="page-summary">
        <div class="page-summary-icon"><span class="an an-stack"></span></div>
        <div class="page-summary-text">
            <p class="po-font-subtitle">O que são acumuladores?</p>
            <p class="page-summary-hint">
                No Domínio, os <strong>acumuladores</strong> são os códigos que ligam os eventos da folha
                (salário, INSS, FGTS, férias, rescisão, juros, multa, desconto etc.) às contas contábeis
                e aos históricos padrão. Cada vigência define conta de débito/crédito, pagamento, juros,
                multa e demais rubricas usadas na contabilização.
            </p>
            <p class="page-summary-hint po-mt-1">
                Este relatório exporta essa configuração da empresa em Excel, para conferência e auditoria.
                O arquivo é enviado para o e-mail do seu usuário.
            </p>
        </div>
    </div>

    <form #form="ngForm" (ngSubmit)="requestAcumuladores(form)">
        <div class="rpt-section po-mt-3">
            <div class="rpt-section-header">
                <i class="an an-gear"></i>
                <span>Configuração do Relatório</span>
            </div>
            <div class="rpt-section-body">
                <div class="po-row">
                    <app-empresa-combo class="po-lg-6 po-md-8 po-sm-12" name="idEmpresa" [(ngModel)]="idEmpresa"
                        label="Empresa" [required]="true"
                        placeholder="Buscar por código ou nome da empresa..."
                        help="Digite o nome ou o código Domínio. O sistema usa o código Domínio da empresa no relatório.">
                    </app-empresa-combo>
                </div>
                <div class="rpt-action-row po-mt-3">
                    <po-button p-label="Gerar Relatório de Acumuladores"
                        [p-loading]="isLoading"
                        [p-disabled]="isLoading"
                        (p-click)="requestAcumuladores(form)">
                    </po-button>
                </div>
            </div>
        </div>

        <div class="rpt-section po-mt-3">
            <div class="rpt-section-header">
                <i class="an an-lightbulb"></i>
                <span>Como Funciona</span>
            </div>
            <div class="rpt-section-body">
                <div class="rpt-info-steps">
                    <div class="rpt-info-step">
                        <span class="rpt-step-number">1</span>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Busque a empresa</p>
                            <p class="rpt-step-desc">Digite o nome ou o código. A busca usa o cadastro do Ecco e envia o código Domínio (<em>codi_emp</em>) no endpoint.</p>
                        </div>
                    </div>
                    <div class="rpt-info-step">
                        <span class="rpt-step-number">2</span>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Gere o relatório</p>
                            <p class="rpt-step-desc">Clique em "Gerar Relatório de Acumuladores". O pedido vai para o Domínio e a tela não espera o Excel.</p>
                        </div>
                    </div>
                    <div class="rpt-info-step">
                        <span class="rpt-step-number">3</span>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Receba por e-mail</p>
                            <p class="rpt-step-desc">A planilha chega no e-mail cadastrado no seu usuário. O processamento pode levar alguns minutos.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</po-page-default>
